<template>
  <m-categories-300/>
</template>

<script>
export default {
  name: "Categories"
}
</script>

<style scoped>

</style>